module.exports = __webpack_public_path__ + "static/img/第二十三届.886d2c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第二十三届.png
// module id = EaQn
// module chunks = 1